import script from "./CarData.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarData.vue?vue&type=script&lang=ts&setup=true"

import "./CarData.vue?vue&type=style&index=0&id=008772f2&scoped=true&lang=css"

import exportComponent from "/builds/rentalcar-app/admin-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008772f2"]])

export default __exports__